<button mat-button (click)="toggleFlyout()" class="sales-tax-invoice-params-opener">
	<i class="fa fa-plus-square fa-lg grayImage" aria-hidden="true"></i>
	<span>Import Payment Card File</span>
</button>
<ng-template cdk-portal>
	<div class="linq-drawer-content">
		<header class="linq-drawer-header">
			<h3 class="linq-heading">{{ header }}</h3>
			<button class="linq-drawer-header__close linq-button-close-lg" (click)="closeFlyout()">
				<mat-icon>clear</mat-icon>
			</button>
		</header>
		<div class="linq-drawer-inner-content linq-drawer-inner-content--spaced">
			<sl-file-upload [allowedExtensions]="allowedExtensions" readAsText="true" (fileUploaded)="fileChangeEvent($event)" [buttonText]="buttonText">
			</sl-file-upload>
			<div class="error-message-box" *ngIf="data && !data.Succeeded">
				<h4>The following errors were encountered on import:</h4>
				<ul>
					<li *ngFor="let error of data.Errors">{{ error }}</li>
				</ul>
			</div>
		</div>
		<footer class="linq-drawer-footer">
			<button type="button" mat-stroked-button color="primary" class="linq-button--secondary" (click)="closeFlyout()">Cancel</button>
			<span class="spacer"></span>
			<button type="button" mat-raised-button color="primary" [disabled]="!file" (click)="parseCsvToList()">Continue Import</button>
		</footer>
	</div>
</ng-template>
